export default __webpack_public_path__ + "static/logo-d6a7c709a97d314a9c0cc1911cbdc75d.png";